module.exports = __webpack_public_path__ + "static/media/b1.2770c975.jpg";